import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { createQueryParams } from '../../utils/query-params.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CitiesService {
  private baseUrl = 'api/public';

  constructor(private http: HttpClient) {}

  // Function to get cities based on category
  getCities(category: 'all' | 'domestic' | 'international'): Observable<any[]> {
    const params = new HttpParams().set('category', category);
    return this.http.get<any[]>(
      `${environment.apiUrl}/${this.baseUrl}/cities`,
      {
        params,
      }
    );
  }

  // Function to search cities for autocomplete
  searchCities(query: any): Observable<any[]> {
    let params = createQueryParams(query);
    return this.http.get<any[]>(
      `${environment.apiUrl}/${this.baseUrl}/cities?${params}`
    );
  }
}
